import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { KeycloakService } from "@youm-front/keycloak/data-access";
import { KeycloakToken } from "@youm-front/keycloak/domain";
import { merge, of } from "rxjs";
import { catchError, mergeMap, concatMap, filter } from "rxjs/operators";
import { AccountAuthActions } from "../actions";

@Injectable()
export class AccountAuthEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly keycloakService: KeycloakService
  ) {}

  keycloakSignIn$ = createEffect(() =>
    merge(
      this.actions$.pipe(ofType(AccountAuthActions.keycloakSignIn)),
      this.keycloakService.onSuccessRedirectToRedirectUri$
    ).pipe(
      concatMap(() =>
        this.keycloakService.init$.pipe(
          mergeMap((_) => (_ ? of(_) : this.keycloakService.login())),
          filter((_): _ is KeycloakToken => !!_),
          mergeMap((_) => [
            AccountAuthActions.keycloakSignInSuccess({ token: _ })
          ]),
          catchError((error: Error) => [
            AccountAuthActions.keycloakSignInFailure({
              error: error.message
            })
          ])
        )
      )
    )
  );

  keycloakSignOut$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AccountAuthActions.keycloakSignOut),
        mergeMap(() => this.keycloakService.init$),
        filter((_) => !!_),
        mergeMap(() => this.keycloakService.signOut())
      ),
    { dispatch: false }
  );
}
